import React, {useState} from "react";
import {Step, StepLabel, Stepper, Typography} from "@material-ui/core";
import UploadFile from "./UploadFile";
import {createStructuredSelector} from "reselect";
import {connect, useDispatch} from "react-redux";
import {selectCurrentStep, selectLanguages, selectMachineTranslation, selectMTmodel, selectTransUnits} from "../reducers/selectors";
import TranslateFile from "./TranslateFile";
import DownloadFile from "./DownloadFile";
import LanguagePicker from "./LanguagePicker";
import {updateFileToDownload} from "../actions/fileActions";
import ActiveStep from "./SvgIcons/ActiveStep";
import NonActiveStep from "./SvgIcons/NonActiveStep";
//import { ReactComponent as StepperActive } from "../assets/images/stepper/stepper-active.svg";
//import { ReactComponent as StepperNotActive } from "../assets/images/stepper/stepper-no-active.svg";

const LinearStepper = ({modelMT, file, translation, languages, currentStep}) => {
  const dispatch = useDispatch();

  function getSteps() {
    return ["Upload file", "Choose languages", "Translate file", "Download file"];
  }

  function getStepContent(currentStep) {
    const isLastStep = activeStep === steps.length - 1;
    switch (currentStep) {
      case 0:
        return <UploadFile/>;
      case 1:
        return <LanguagePicker/>;
      case 2:
        return <TranslateFile/>;
      case 3:
        return <DownloadFile/>;
      default:
        return null;
    }
  }

  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const handleNext = () => {
    setActiveStep(activeStep + 1);
    console.log(activeStep);
    if (activeStep === 0) {
    }
    if (activeStep === 1) {
      const segments = translation.translatedFiles.semgments.map((x) => x.targetText);

      dispatch(updateFileToDownload(segments));
    }
  };

  const handlePrev = () => {
    setActiveStep(activeStep - 1);
  };

  return (
      <div>
        <Stepper activeStep={currentStep} orientation="horizontal">
          {steps.map((step, index) => {
            return (
                <Step key={index}>
                  <StepLabel StepIconComponent={currentStep === index ? ActiveStep : NonActiveStep}>{step}</StepLabel>
                  {/* //currentStep === index ? StepperActive : StepperNotActice */}
                </Step>
            );
          })}
        </Stepper>
        <Typography component={"span"}>{getStepContent(currentStep)}</Typography>
      </div>
  );
};

const styles = (theme) => ({
  root: {
    width: "90%",
  },
  backButton: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
});
const mapDispatchToProps = (dispatch) => {
  return {
    langId: (langId) => dispatch(langId(langId)),
  };
};

const mapStateToProps = createStructuredSelector({
  modelMT: selectMTmodel,
  file: selectTransUnits,
  translation: selectMachineTranslation,
  languages: selectLanguages,
  currentStep: selectCurrentStep,
});
export default connect(mapStateToProps, mapDispatchToProps)(LinearStepper);
